import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ContentProvider } from "@/lib/content";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Kesfet from "@/pages/Kesfet";
import Galeri from "@/pages/Galeri";
import Ziyaret from "@/pages/Ziyaret";
import Iletisim from "@/pages/Iletisim";
import Gizlilik from "@/pages/Gizlilik";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/admin/Admin";
import Bilet from "@/pages/Bilet";
import BiletDetay from "@/pages/BiletDetay";
const Terminal = lazy(() => import("@/pages/terminal/Terminal"));

const PAGES = [
  ["kesfet", "discover", Kesfet],
  ["galeri", "gallery", Galeri],
  ["ziyaret", "visit", Ziyaret],
  ["iletisim", "contact", Iletisim],
  ["gizlilik", "privacy", Gizlilik],
];

function App() {
  return (
    <BrowserRouter>
      <ContentProvider>
        <Routes>
          <Route path="yonetim" element={<Admin />} />
          <Route path="terminal" element={<Suspense fallback={<div className="min-h-screen bg-forest-dark" aria-busy="true" />}><Terminal /></Suspense>} />
          <Route element={<Layout lang="tr" />}>
            <Route index element={<Home />} />
            {PAGES.map(([tr, , C]) => <Route key={tr} path={tr} element={<C />} />)}
            <Route path="bilet" element={<Bilet />} />
            <Route path="bilet/:token" element={<BiletDetay />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="en" element={<Layout lang="en" />}>
            <Route index element={<Home />} />
            {PAGES.map(([, en, C]) => <Route key={en} path={en} element={<C />} />)}
            <Route path="tickets" element={<Bilet />} />
            <Route path="tickets/:token" element={<BiletDetay />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </ContentProvider>
    </BrowserRouter>
  );
}

export default App;
